module.exports = __webpack_public_path__ + "img/about-career-1.4770fbdf.jpg";